<template>
  <adv-input-spinner
    :mini-cart="miniCart"
    :min="min"
    :max="max"
    :quantity="localQuantity"
    :button-css="buttonCss"
    :unavailable="!productCodeId"
    v-on:quantity-changed="quantityChanged"></adv-input-spinner>
</template>

<script>
import AdvInputSpinner from './presentation/AdvInputSpinner'
import productMixin from './mixins/productMixins'
import store from '../../vue/store'

export default {
  name: 'AdvCartInputSpinner',
  props: {
    productId: {
      type: Number
    },
    miniCart: {
      type: Boolean,
      default: false
    },
    productCodeId: {
      type: Number
    },
    quantity: {
      type: Number,
      default: 0
    },
    buttonCss: {
      type: String,
      default: ''
    }
  },
  components: {
    AdvInputSpinner
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.1',
      localQuantity: 0
    }
  },
  mounted () {
    this.localQuantity = this.quantity
  },
  watch: {
    productCodeId (val) {
      if (this.futureFirstEdition) {
        this.localQuantity = store.getters.cartSpinnerQuantity(val)
        return
      }
      this.localQuantity = (Number(this.productCodeData.productStock) + Number(this.productCodeData.productPendingStock)) > 0 ? store.getters.cartSpinnerQuantity(val) : 0
    },
    quantity (val) {
      this.localQuantity = val
    }
  },
  computed: {
    productMetaData () {
      return this.productData?.metaData
    },
    futureFirstEdition () {
      const currentDate = new Date()
      const firstEditionDate = new Date(this.productMetaData?.firstEditionDate)

      return firstEditionDate > currentDate ? firstEditionDate : null
    },
    min () {
      if (this.futureFirstEdition) {
        return 1
      }
      return (Number(this.productCodeData.productStock) + Number(this.productCodeData.productPendingStock)) > 0 ? 1 : 0
    },
    max () {
      if (this.futureFirstEdition) {
        // @TODO 10 is random number
        return 10
      }
      return Number(this.productCodeData.productStock) + Number(this.productCodeData.productPendingStock)
    }
  },
  methods: {
    quantityChanged (quantity) {
      this.localQuantity = quantity
      this.$emit('quantity-changed', quantity)
    }
  }
}
</script>
